import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {ItemKey} from "../item/core/ItemKey";
import {ItemGroupModel} from "../item/core/ItemGroupModel";
import {CellKey} from "./CellKey";
import {Point} from "../utils/Point";
import {Tile} from "../utils/Tile";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";



export class CellConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(CellConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(CellConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._key = CellKey.NONE;
        this._tile = new Tile();
        this._offset = new Point();
        this._item = null;
        this._group = null;
        this._count = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get count() {
        return this._count;
    }

    set count(value) {
        this._count = value;
    }

    get tile() {
        return this._tile;
    }

    set tile(value) {
        this._tile = value;
    }

    get offset() {
        return this._offset;
    }

    set offset(value) {
        this._offset = value;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    valid() {

        if (this.key && !CellKey.is(this.key)) {
            return false;
        }

        if (this.tile && !this.tile.valid()) {
            return false;
        }

        if (this.offset && !this.offset.valid()) {
            return false;
        }

        if (this.item && (!this.item.valid() || this.item.any())) {
            return false;
        }

        if (this.item && !RedactorUtils.getItems().some(item => item.key?.equal(this.item))) {
            console.log('Invalid config: Missing Item for cell item');
            return false;
        }

        return true;
    }

    empty() {
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CellConfig());
        } else if (target instanceof CellConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CellConfig, {
    _key: alias("key", CellKey.schema()),
    _tile: alias("tile", Tile.schema()),
    _offset: alias("offset", Point.schema()),
    _item: alias("item", ItemKey.schema()),
    _group: alias("group", ItemGroupModel.schemaByCode()),
    _count: alias("count", Schema.primitive()),
});